import { Component, OnInit ,ViewChild,AfterViewInit} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PaymentService } from 'src/app/services/payment.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-payments-v2',
  templateUrl: './payments-v2.component.html',
  styleUrls: ['./payments-v2.component.scss']
})
export class PaymentsV2Component implements OnInit,AfterViewInit {


  paymentList: any = [];
  show: boolean = false
  filterForm!: FormGroup;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  constructor(private formBuilder: FormBuilder, private paymentService: PaymentService, private spinner: NgxSpinnerService) { }


  ngAfterViewInit(): void {
    this.dtTrigger.next(this);
  }

  
  rerender() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(this);
    });
  }

  ngOnInit(): void {

    this.show = false
    this.spinner.show()
    this.paymentService.getPaymentDetails(null, null, null).subscribe(res => {

      this.paymentList=res.data;

      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10,
        stateSave: true,
        lengthMenu: [[10, 20, 30, -1], [10, 20, 30, "All"]],
        processing: true,
        destroy: true,
        searching: true
      };
      this.rerender();

      this.show = true
      this.spinner.hide();
    })

  

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
    }, { validator: this.dateLessThan('fromDate', 'toDate') });
  }
  dateLessThan(from: string, to: string) {
    return (group: FormGroup): {[key: string]: any} => {
      let f = group.controls[from];
      let t = group.controls[to];
      if (f.value && t.value && f.value > t.value) {
        return {
          dates: "To Date should be greater than From Date"
        };
      }
      return {};
    }
  }

  submitFilterForm() {
    this.spinner.show()
    this.paymentService.getPaymentDetails(null, this.filterForm.controls['fromDate'].value, this.filterForm.controls['toDate'].value).subscribe(res => {

      // res.data.forEach((element: any) => {
        
      //     this.paymentList.unshift(element)
        
      // });
      this.paymentList=res.data;

      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10,
        stateSave: true,
        lengthMenu: [[10, 20, 30, -1], [10, 20, 30, "All"]],
        processing: true,
        destroy: true,
        searching: true
      };
      this.rerender();

      this.show=true
      this.spinner.hide()
    })
  }

}
